import React, { useEffect } from 'react'
import { LoginContextData } from '../common/utils/context_loginquestion'
import LoginPageComponent from '../components/login/login';
import { ColorRing } from 'react-loader-spinner';

function LoginPage({ onHandleOTPCheck }) {
    const [loginQuestionContextAPI, otpSettings, declaration] = LoginContextData(); // get the login questions
    const handleOTPCheck = (sheetId, passingPercentage) => {
        onHandleOTPCheck(sheetId, passingPercentage);
    }
    useEffect(() => {
        sessionStorage.removeItem('refreshed');
    }, [])
    return (
        <>
            {
                Object.keys(loginQuestionContextAPI).length > 0 ?
                    <LoginPageComponent
                        questions={loginQuestionContextAPI}
                        onHandleOTPCheck={handleOTPCheck}
                        otpSettings={otpSettings}
                        declaration={declaration}
                    />
                    : <div style={styles.loaderContainer}>
                        <ColorRing color="#00BFFF" height={80} width={80} />
                    </div>
            }
        </>
    )
}

export const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
};

export default LoginPage